import { useEffect } from "react";
import { api } from "../api";

// data-testid of an input -> suggestion list it should offer. Any input can also opt in with data-ac="<list>".
const FIELD_LIST = {
  "recipe-name-input": "dish", "recipe-category-input": "dish_category", "ingredient-name-input": "ingredient", "ingredient-new-category": "ingredient_category",
  "supplier-name-input": "supplier", "final-bill-name": "customer", "expense-payee": "payee", "expense-new-category": "expense_category",
  "hall-booking-organiser": "guest", "booking-guest-name": "guest", "hall-name-input": "hall", "room-cat-name": "room_category",
  "waiter-name-input": "staff", "staff-name-input": "staff", "branch-name-input": "",
};

function ensureList(id, values) {
  let dl = document.getElementById(id);
  if (!dl) { dl = document.createElement("datalist"); dl.id = id; document.body.appendChild(dl); }
  dl.replaceChildren(...values.map((v) => Object.assign(document.createElement("option"), { value: v })));
}

export function useSmartFields(branch) {
  useEffect(() => {
    if (!branch) return undefined;
    let lists = {}, last = 0;
    const refresh = async () => {
      if (Date.now() - last < 15000) return;
      last = Date.now();
      try { lists = (await api.get("/suggest", { params: { branch } })).data; Object.entries(lists).forEach(([k, v]) => ensureList(`ac-${k}`, v)); } catch { /* suggestions are optional */ }
    };
    const onFocus = (e) => {
      const el = e.target;
      if (el.tagName !== "INPUT") return;
      const key = el.dataset.ac ?? FIELD_LIST[el.dataset.testid];
      if (key === undefined) return;
      el.classList.add("uc");
      if (key) { el.setAttribute("list", `ac-${key}`); el.setAttribute("autocomplete", "off"); refresh(); }
    };
    document.addEventListener("focusin", onFocus);
    refresh();
    return () => document.removeEventListener("focusin", onFocus);
  }, [branch]);
}
